import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import Colors from '../colors';
const styles = {
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: Colors.advanceBlue10,
    paddingHorizontal: 16,
    borderRadius: 4
  }
};
export default function Container(props) {
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.container, props.style]
  }, props.children);
}
Container.propTypes = {
  style: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=container.js.map